import { hasPermission } from '@/hooks/useBackendMenu'
import { StatusAprovacao } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import StatusOcorrencia from '../atoms/StatusOcorrencia'
import FormDetalhesAbono from '../forms/DetalhesAbono'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import useService from '../service'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export default function DetalhesAbono() {
    const {
        handleAprovar,
        handleExcluir,
        handleReprovar,
        handleAtualizarAbono,
    } = useService()
    const { id } = useParams()
    const { data, getFuncionarioNome } = useDigitacaoContext()

    const abono = data?.find(({ abono }) => abono?.id === Number(id))?.abono

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()
    const [excluindo, setExcluindo] = useState(false)

    if (!abono) return null

    const referencia = `${getFuncionarioNome(abono.funcionarioId)} · ${dayjs.utc(abono.data).format('DD/MM/YYYY')}`

    const podeExcluir =
        hasPermission(['delete', 'Abonos']) || funcionarioPodeAjustar

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'Abonos'])}
            defaultValues={abono}
            onSubmit={
                hasPermission(['update', 'Abonos'])
                    ? handleAtualizarAbono
                    : undefined
            }
        >
            <Dialog.Title action="Detalhes do abono">{referencia}</Dialog.Title>
            <Dialog.Content>
                <FormDetalhesAbono />
                <Dialog.Content.Footer>
                    <StatusOcorrencia
                        tipoOcorrencia="ABONO"
                        referencia={referencia}
                        onApprove={
                            hasPermission(['update', 'Abonos'])
                                ? () => handleAprovar('ABONO', abono)
                                : undefined
                        }
                        onReject={
                            hasPermission(['update', 'Abonos'])
                                ? ({ motivo }) =>
                                      handleReprovar('ABONO', {
                                          id: abono.id,
                                          motivo,
                                      })
                                : undefined
                        }
                    />
                </Dialog.Content.Footer>
                <ConfirmarExclusao
                    width="2xl"
                    open={excluindo}
                    onClose={() => setExcluindo(false)}
                    exigirMotivo={
                        abono.statusAprovacao != StatusAprovacao.PENDENTE
                    }
                    onConfirm={({ motivo }) =>
                        handleExcluir('ABONO', { ...abono, motivo })
                    }
                    title="Tem certeza que deseja excluir o abono?"
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                {podeExcluir && (
                    <Dialog.Actions.PrimaryButton
                        color="error"
                        data-testid="dialog-delete-button"
                        onClick={() => setExcluindo(true)}
                    >
                        Excluir
                    </Dialog.Actions.PrimaryButton>
                )}
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
